(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    class CCMegaTabs extends HTMLElement {
    connectedCallback() {
      this.tabLinks = Array.from(this.querySelectorAll('[data-cc-tab]'));
      this.panes = Array.from(this.querySelectorAll('[data-cc-pane]'));

      this.tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('mouseenter', () => this.activate(tabLink.dataset.ccTab));
        tabLink.addEventListener('focus', () => this.activate(tabLink.dataset.ccTab));
        tabLink.addEventListener('click', (event) => {
          // A tab that is already selected (hovered/focused into view) should
          // behave like a normal link and navigate to its "all <category>"
          // page - only an inactive tab intercepts the click to switch panes
          // in place. Without this check every click was treated as a pane
          // switch, even on the tab already showing, so the link never
          // actually went anywhere.
          const alreadyActive = tabLink.classList.contains('is-active');
          if (this.panes.length && !alreadyActive) {
            event.preventDefault();
            this.activate(tabLink.dataset.ccTab);
          }
        });
      });
    }

    activate(key) {
      this.tabLinks.forEach((tabLink) => {
        tabLink.classList.toggle('is-active', tabLink.dataset.ccTab === key);
      });
      this.panes.forEach((pane) => {
        pane.hidden = pane.dataset.ccPane !== key;
      });
    }
  }

  if (!customElements.get('cc-mega-tabs')) {
    customElements.define('cc-mega-tabs', CCMegaTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
